import React from 'react';
import { Program } from '../types';
import './ProgramCard.css';

interface ProgramCardProps {
  program: Program;
  onClick: () => void;
}

const ProgramCard: React.FC<ProgramCardProps> = ({ program, onClick }) => {
  return (
    <div className="program-card fractal-layer" onClick={onClick}>
      <div className="program-card-content">
        <h2>{program.title}</h2>
        <p>{program.content}</p>
      </div>
      <div className="program-card-footer">
        <button className="btn btn-primary">Apply Now</button>
      </div>
    </div>
  );
};

export default ProgramCard;